import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  perfText: {
    display: "block",
    fontSize: 13,
    lineHeight: "16px",
    margin: 0,
    color: theme.palette.text.primary,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    [theme.breakpoints.down("sm")]: {
      fontWeight: 400
    }
  },
  perfComment: {
    display: "block",
    fontSize: 12,
    lineHeight: "16px",
    color: theme.palette.text.secondary,
    marginTop: 3,
    [theme.breakpoints.down("sm")]: {
      marginTop: 16
    }
  },
  circleBorder: {
    display: "inline-block",
    border: `1px solid ${theme.palette.common.black}`,
    borderRadius: "50%"
  },
  rectBorder: {
    display: "inline-block",
    border: `1px solid ${theme.palette.common.black}`,
    borderRadius: 0
  },
  alert: {
    color: theme.palette.warning.dark
  },
  dot: {
    width: 2,
    height: 2,
    borderRadius: "50%",
    margin: 3,
    display: "block",
    background: theme.palette.common.black
  }
}));
